import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { YearSelectorDirective } from './directives/set-date-current-year.directive';
import { CurrencyOnlyDirective } from './directives/currency-only.directive';
import { CurrencyPositiveNegativeDirective } from './directives/currency-positive-negative.directive';
import { DateFormatOnlyDirective } from './directives/date-format-only.directive';
import { NumericOnlyFourDecimalDirective } from './directives/numeric-only-four-decimal.directive';
import { NumericOnlyDirective } from './directives/numeric-only.directive';
import { ReferenceNumberOnlyDirective } from './directives/reference-number-only.directive';
import { TwoDigitDecimaNumberDirective } from './directives/twoDigitDecimalNumber.directive';
import { AdditionalEmailsPipe } from './pipes/additional-emails.pipe';
import { AdditionalVehiclesPipe } from './pipes/additional-vehicles.pipe';
import { TrimCommentsPipe } from './pipes/trim-comments.pipe';
import { LicensePlateDirective } from './directives/license-plate.directive';
import { IsParkerSelected } from './pipes/isParkerSelectedForUpdate.pipe';
import { IsParkerErrorOnMassUpdate } from './pipes/isParkerErrorOnMassUpdate.pip';
import { PasteHandler } from './directives/paste-handler.directive';
import {
  IgxButtonModule,
  IgxIconModule,
  IgxNavigationDrawerModule,
  IgxRippleModule,
  IgxToggleModule,
  IgxTreeModule,
  IgxGridModule,
  IgxNavbarModule,
  IgxTabsModule,
} from '@infragistics/igniteui-angular';

// import { FilterTextboxModule } from './filter-textbox/filter-textbox.module';
// import { PaginationModule } from './pagination/pagination.module';

// import { CapitalizePipe } from './pipes/capitalize.pipe';
// import { TrimPipe } from './pipes/trim.pipe';
// import { SortByDirective } from './directives/sortby.directive';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    IgxButtonModule,
    IgxIconModule,
    IgxNavigationDrawerModule,
    IgxRippleModule,
    IgxToggleModule,
    IgxTreeModule,
    IgxGridModule,
    IgxNavbarModule,
    IgxTabsModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    YearSelectorDirective,
    CurrencyOnlyDirective,
    CurrencyPositiveNegativeDirective,
    DateFormatOnlyDirective,
    NumericOnlyFourDecimalDirective,
    NumericOnlyDirective,
    ReferenceNumberOnlyDirective,
    TwoDigitDecimaNumberDirective,
    PasteHandler,
    AdditionalEmailsPipe,
    AdditionalVehiclesPipe,
    TrimCommentsPipe,
    LicensePlateDirective,
    IsParkerSelected,
  ],
  declarations: [
    LicensePlateDirective,
    YearSelectorDirective,
    CurrencyOnlyDirective,
    CurrencyPositiveNegativeDirective,
    DateFormatOnlyDirective,
    NumericOnlyFourDecimalDirective,
    NumericOnlyDirective,
    ReferenceNumberOnlyDirective,
    TwoDigitDecimaNumberDirective,
    AdditionalEmailsPipe,
    AdditionalVehiclesPipe,
    TrimCommentsPipe,
    IsParkerSelected,
    IsParkerErrorOnMassUpdate,
    PasteHandler,
  ],
})
export class SharedModule {}
